export { MenuSidebarComponent as MenuSidebar } from "./component";



// WEBPACK FOOTER //
// ./src/components/organisms/menu-sidebar/index.tsx